import { ROUTES, ROUTE_WITH_QUERY } from '@/admin/config/routes';

/**
 * Handles role-based routing logic
 * Redirects users to appropriate pages based on their role and permissions
 */
export const handleRoleBasedRouting = (
  userRole: string,
  organizationId: string | null,
  navigate: (path: string, options?: { replace: boolean }) => void
) => {
  switch (userRole) {
    case 'super-admin':
    case 'account-manager':
      navigate(ROUTES.ACCOUNTS, { replace: true });
      break;
    case 'admin':
    case 'teacher':
      if (organizationId) {
        navigate(ROUTE_WITH_QUERY.SCHOOL_DETAILS_WITH_TAB(organizationId, 'general'), {
          replace: true,
        });
      } else {
        navigate(ROUTES.SCHOOLS, { replace: true });
      }
      break;
    case 'region-manager':
      if (organizationId) {
        navigate(ROUTE_WITH_QUERY.SCHOOL_DETAILS_WITH_TAB(organizationId, 'general'), {
          replace: true,
        });
      } else {
        navigate(ROUTES.SCHOOLS, { replace: true });
      }
      break;
    case 'guest':
      navigate('/login', { replace: true });
      break;
    default:
      navigate(ROUTES.SCHOOLS, { replace: true });
      break;
  }
};
